import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import {
    Box,
    Typography,
    Button,
    FormControl,
    TextField,
    InputAdornment,
    IconButton,
    useTheme,
    Grid,
    useMediaQuery,
    Tabs,
    Tab,
    darken,
    Dialog,
    Select,
    MenuItem,
    InputLabel,
    Tooltip,
    Radio,
    RadioGroup,
    FormControlLabel,
    DialogTitle,
    DialogContent
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../form/FormTextField";
import FormFileInput from "../form/FormFileInput";
import { setAlert } from "../../features/slices/alertSlice";
import Image from "../common/Image";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import * as Constant from "../../features/constant";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
    useSaveTrackingDataMutation,
    useGetBankAccountsQuery,
    useGetDepositDescQuery
} from "../../features/api/userApiSlice";
import QrCodeIcon from '@mui/icons-material/QrCode';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {
    useGetDepositCategoryQuery
} from "../../features/api/publicApiSlice"
import TrackFbq from "../common/TrackFbq";
import {
    useLazyGetCryptoAmountQuery
} from "../../features/api/publicApiSlice";
import AddIcon from '@mui/icons-material/Add';
import {
    useDepositMutation,
    useGetDepositDetailsQuery,
} from "../../features/api/transactionApiSlice";
import CloseIcon from "@mui/icons-material/Close";
import WalletIcon from '@mui/icons-material/Wallet';

const DepositMobile = () => {
    const location = useLocation();

    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();
    const pgScrollRef = useRef(null);
    const bankScrollRef = useRef(null);
    const eWalletScrollRef = useRef(null);
    const [openTnc, setOpenTnc] = React.useState(false);


    const [tabValue, setTabValue] = useState(0);

    const [amount, setAmount] = useState('');
    const [reamount, setReamount] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [timer, setTimer] = useState(5);
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [isCooldown, setIsCooldown] = useState(false);
    const [gatewaySubmit, setGatewaySubmit] = useState(false);
    const [eWalletSubmit, setEWalletSubmit] = useState(false);

    const { data: fallbackDetails } = useGetDepositDetailsQuery();
    const depositDetails = location.state?.depositDetails ?? fallbackDetails?.result;

    const bankDetails = depositDetails?.banks?.filter(
        (detail) => detail?.bankCategory === 'BANK' || !detail?.bankCategory
    ) || [];

    const eWalletDetails = depositDetails?.banks?.filter(
        (detail) => detail?.bankCategory === 'EWALLET'
    ) || [];

    const getAvailableMethods = (bank) => {
        const type = bank?.type?.toLowerCase() || "bank";
        if (type === "qrcode") return ["qrCode"];
        if (type === "bank") return ["bank"];
        if (type === "bank&qrcode") return ["bank", "qrCode"];
        if (type === "qrcode&bank") return ["qrCode", "bank"];
        return ["bank"];
    };

    const bankMethodOptions = Array.from(
        new Set(bankDetails.flatMap((bank) => getAvailableMethods(bank)))
    );

    const [selectedBankMethod, setSelectedBankMethod] = useState("bank");
    const [selectedQrCodeMethod, setSelectedQrCodeMethod] = useState("bank");
    const [filteredBankDetails, setFilteredBankDetails] = useState(null);
    const [filteredEWallet, setFilteredEWallet] = useState(null);
    const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";


    const [selectedQuickpay, setSelectedQuickpay] = useState(null);
    const [allQuickpayBank, setAllQuickpayBank] = useState([]);
    const [selectedQuickpayBank, setSelectedQuickpayBank] = useState(null);
    const [selectedQuickpayBankCategory, setSelectedQuickpayBankCategory] = useState("BANK");

    useEffect(() => {
        if (!depositDetails?.paymentGateways) return;

        const gateways = depositDetails.paymentGateways;
        const keys = Object.keys(gateways);
        if (keys.length === 0) return;
        const firstGateway = gateways[keys[0]];

        setSelectedQuickpay(firstGateway?.paymentGateway ?? null);
        setAllQuickpayBank(firstGateway?.banks || []);
        setSelectedQuickpayBank(firstGateway?.banks?.[0] ?? null);
    }, [depositDetails]);

    const [errorMessage, setErrorMessage] = useState("");

    const [minDeposit, setMinDeposit] = useState(0);
    const [maxDeposit, setMaxDeposit] = useState(0);

    const [open, setOpen] = useState(false);
    const isKR = process.env.REACT_APP_COUNTRY === "KR";

    const handlePreviewOpen = () => {
        setOpen(true);
    };

    const handlePreviewClose = () => {
        setOpen(false);
    };


    useEffect(() => {
        if (shouldNavigate) {
            navigate(Constant.getPath('/'));
        }
    }, [shouldNavigate, navigate]);



    const { t } = useTranslation();
    const { data: depositCategory = [] } = useGetDepositCategoryQuery();
    const categorySortOrder = depositCategory?.result || { bank: 1, ewallet: 2, paymentgateway: 3 };

    const depositType = [];
    if (bankDetails && Object.keys(bankDetails).length > 0) {
        depositType.push({ label: t("walletcard.depositpage.title"), category: "bank" });
    }

    if (eWalletDetails && Object.keys(eWalletDetails).length > 0) {
        depositType.push({ label: t("walletcard.depositpage.ewallet"), category: "ewallet" });
    }

    if (depositDetails?.paymentGateways && Object.keys(depositDetails.paymentGateways).length > 0) {
        depositType.push({ label: t("walletcard.depositpage.quickpay.title"), category: "paymentgateway" });
    }

    const depositSchema = yup.object().shape({
        amount: yup
            .number()
            .typeError(t("validation.amountonly"))
            .min(minDeposit, t("validation.minamount"))
            .max(maxDeposit, t("validation.maxamount"))
            .required(t("validation.amountisrequired")),
        receipt: yup.mixed().test("file", t("validation.receipt"), (value) => {
            if (value?.length > 0) {
                return true;
            }
            return false;
        }).test("fileSize", t("validation.filesize"), (value) => {
            // Check if the file size exceeds 1MB
            if (value?.length > 0) {
                const file = value[0];
                return file.size <= 5 * 1024 * 1024;
            }
            return true;
        }),
        // ignore for now
        // promotion: yup.string().required("Please select a promotion."),
    });

    const quickpaySchema = yup.object().shape({
        amount: yup
            .number()
            .typeError(t("validation.amountonly"))
            .min(minDeposit, t("validation.minamount"))
            .max(maxDeposit, t("validation.maxamount"))
            .required(t("validation.amountisrequired")),
    });

    const { control, handleSubmit, setValue, reset } = useForm({
        resolver: yupResolver(depositSchema),
    });

    const {
        control: qpControl,
        handleSubmit: handleQpSubmit,
        setValue: setQpValue,
        reset: resetQp,
    } = useForm({
        resolver: yupResolver(quickpaySchema),
    });

    const sortedDepositType =
        depositCategory?.result && Object.keys(depositCategory.result).length > 0
            ? depositType.slice().sort(
                (a, b) => (categorySortOrder[a.category] ?? 99) - (categorySortOrder[b.category] ?? 99)
            )
            : depositType;

    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        if (!selectedCategory && sortedDepositType.length > 0) {
            setSelectedCategory(sortedDepositType[0].category);
        }
    }, [sortedDepositType, selectedCategory]);

    const [selectedBank, setSelectedBank] = useState();
    const [selectedEwalletBank, setSelectedEwalletBank] = useState();

    useEffect(() => {
        if (bankDetails.length === 1) {
            setSelectedBank(bankDetails[0]);
        }
    }, [])

    useEffect(() => {
        if (eWalletDetails.length === 1) {
            setSelectedEwalletBank(eWalletDetails[0]);
        }
    }, [])

    useEffect(() => {
        if (Array.isArray(allQuickpayBank) && allQuickpayBank.some(b => b?.category)) {
            const firstCategory = [...new Set(allQuickpayBank.map(b => b.category))][0];
            setSelectedQuickpayBankCategory(firstCategory || "BANK");
        }
    }, [allQuickpayBank]);

    useEffect(() => {
        if (selectedBankMethod === 'qrCode') {
            const filtered = bankDetails.filter(
                bank => !!bank.qrCodeUrl
            );

            setFilteredBankDetails(filtered);
        } else if (selectedBankMethod === 'bank') {
            const filtered = bankDetails

            setFilteredBankDetails(filtered);
        }
    }, [selectedBankMethod, bankDetails])

    useEffect(() => {
        if (filteredBankDetails?.length > 0 && !selectedBank) {
            setSelectedBank(filteredBankDetails[0]);
        }
    }, [filteredBankDetails])

    useEffect(() => {
        if (setSelectedQrCodeMethod === 'qrCode') {
            const filtered = eWalletDetails.filter(
                ewallet => !!ewallet.qrCodeUrl
            );

            setFilteredEWallet(filtered);
        } else if (setSelectedQrCodeMethod === 'bank') {
            const filtered = eWalletDetails

            setFilteredEWallet(filtered);
        }
    }, [selectedQrCodeMethod])


    useEffect(() => {
        let selectedMinAmount = selectedCategory === 'bank'
            ? selectedBank?.minAmount
            : selectedCategory === 'paymentgateway'
                ? selectedQuickpayBank?.minAmount
                : selectedCategory === 'ewallet'
                    ? selectedEwalletBank?.minAmount
                    : undefined;

        let finalMinDeposit;

        const specificMin = selectedMinAmount;
        const globalMin = depositDetails?.minDeposit;

        if (specificMin != null) {
            finalMinDeposit = (globalMin != null) ? Math.max(specificMin, globalMin) : specificMin;
        }
        else {
            finalMinDeposit = globalMin ?? 0;
        }
        setMinDeposit(finalMinDeposit);

        let selectedMaxAmount = selectedCategory === 'bank'
            ? selectedBank?.maxAmount
            : selectedCategory === 'paymentgateway'
                ? selectedQuickpayBank?.maxAmount
                : selectedCategory === 'ewallet'
                    ? selectedEwalletBank?.maxAmount
                    : undefined;

        let finalMaxDeposit;

        const specificMax = selectedMaxAmount;
        const globalMax = depositDetails?.maxDeposit;

        if (specificMax != null) {
            finalMaxDeposit = (globalMax != null) ? Math.min(specificMax, globalMax) : specificMax;
        }
        else {
            finalMaxDeposit = globalMax ?? 0;
        }

        setMaxDeposit(finalMaxDeposit);

    }, [selectedCategory, selectedBank, selectedQuickpayBank, selectedEwalletBank, depositDetails]);

    const [deposit, { data, isLoading, isError, isSuccess, error }] =
        useDepositMutation();

    const [saveTrackingData] = useSaveTrackingDataMutation();

    const handleTabChange = (event, newValue) => {
        const selectedCategory = sortedDepositType[newValue]?.category;
        setTabValue(newValue);
        setSelectedCategory(selectedCategory);
        setReamount(0);
    };

    useEffect(() => {
        if (!pgScrollRef.current) return;

        pgScrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }, [selectedQuickpay]);

    useEffect(() => {
        if (!bankScrollRef.current) return;

        bankScrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }, [selectedBank]);

    useEffect(() => {
        if (!eWalletScrollRef.current) return;

        eWalletScrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }, [selectedEwalletBank]);

    const submitTrackingData = async () => {
        try {
            const fbc = Cookies.get("_fbc");
            const fbp = Cookies.get("_fbp");

            const payload = {
                fbc: fbc,
                fbp: fbp,
            };
            await saveTrackingData(payload);
        } catch (error) {
            // Handle errors
        }
    }


    const submitDeposit = async (data) => {
        const formData = new FormData();
        //const date = new Date(data.date).toISOString().split("T");
        formData.append("amount", data.amount);
        //formData.append("receiptDateTime", date[0] + ";" + date[1]);
        formData.append("receipt", data.receipt[0]);
        if (selectedCategory === 'bank') {
            formData.append(
                "bankCode",
                selectedBank?.bankCode || bankDetails[0].bankCode
            );
            formData.append("depositMethod", selectedBankMethod);
        }
        else if (selectedCategory === 'ewallet') {
            formData.append(
                "bankCode",
                selectedEwalletBank?.bankCode || selectedEwalletBank[0].bankCode
            );
            formData.append("depositMethod", selectedQrCodeMethod);
        }

        setEWalletSubmit(true);

        if (data.amount > 1000) {
            TrackFbq('trackCustom', 'submitDeposit_' + data.amount);
        }

        await submitTrackingData();
        await deposit({ deposit: formData, paymentGateway: "" }).unwrap().then(() => {
            setEWalletSubmit(false);

            let timerInterval;
            Swal.fire({
                title: t("walletcard.depositpage.deposittitle"),
                html: t("walletcard.depositpage.depositmessage"),
                timer: 3000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b");
                    timerInterval = setInterval(() => {
                        timer.textContent = `${Swal.getTimerLeft()}`;
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                }
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    setShouldNavigate(true);
                    //console.log("I was closed by the timer");
                }
            });
        }).catch((error) => {
            setEWalletSubmit(false);

            Swal.fire({
                icon: 'error',
                title: error?.data?.message || error?.message || "Something went wrong",
                confirmButtonText: "OK"
            });
        });

        // if (!isDisabled) {
        //   setTimer(5);
        //   setIsDisabled(true);
        // }
        const cooldownDuration = process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15;
        const endTime = Date.now() + cooldownDuration * 1000;


        sessionStorage.setItem(
            "cooldownTimer",
            JSON.stringify({ endTime, isCooldown: true })
        );

        setTimer(cooldownDuration);
        setIsCooldown(true);
        // setShowPopup(true);

    };

    const submitQuickpay = async (data) => {
        const formData = new FormData();
        // formData.append("bankCode", selectedQuickpayBank?.bankCode);
        if (isKR && selectedQuickpay === 'SULIFU') {
            if (!selectedUserBank) {
                dispatch(
                    setAlert({
                        isOpen: true,
                        message: t("validation.pleaseselectbank"),
                        variant: "error",
                    })
                );
                return;
            }
            formData.append("bankCode", selectedUserBank.bankCode);
            formData.append("bankAccountNumber", selectedUserBank.bankAccountNumber);
        } else {
            formData.append("bankCode", selectedQuickpayBank?.bankCode);
        }
        formData.append("amount", data?.amount);

        setGatewaySubmit(true);

        Swal.fire({
            title: t("walletcard.depositpage.gatewaytitle"),
            html: t("walletcard.depositpage.gatewaymessage"),
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        if (data?.amount > 1000) {
            TrackFbq('trackCustom', 'submitDeposit_' + data?.amount);
        }

        await submitTrackingData();
        const res = await deposit({
            deposit: formData,
            paymentGateway: selectedQuickpay,
        })

        if (res) {
            Swal.close();
            setGatewaySubmit(false);

            if (res.data.result.paymentUrl && res.data.result.success === true) {
                navigate(Constant.getPath('/'));
                if (selectedQuickpay === "LNWPAY" || selectedQuickpay === "LNWPAYHK") {
                    setTimeout(() => {
                        window.location.href = process.env.REACT_APP_GATEWAY_URL_IFRAME + res.data.result.paymentUrl;
                    }, 500);
                } else {
                    setTimeout(() => {
                        window.location.href = res.data.result.paymentUrl
                    }, 500);
                }
            } else {
                dispatch(
                    setAlert({
                        isOpen: true,
                        message: t("walletcard.depositpage.paymentgatewayError"),
                        variant: "error",
                    })
                );
            }
        }
        else {
            Swal.close();
            setGatewaySubmit(false);
        }
        resetQp();
        // if (!isDisabled) {
        //   setTimer(5);
        //   setIsDisabled(true);
        // }
        // navigate(Constant.getPath('/'));
    };

    useEffect(() => {

        if (amount !== "") {
            const processingFee =
                selectedCategory === 'bank'
                    ? selectedBank?.processingFee ?? 0
                    : selectedCategory === 'paymentgateway'
                        ? selectedQuickpayBank?.processingFee ?? 0
                        : selectedCategory === 'ewallet'
                            ? selectedEwalletBank?.processingFee ?? 0
                            : undefined;
            const reamountValue = parseFloat(amount || 0) + parseFloat(processingFee);

            const effectiveMaxDeposit = maxDeposit;

            if (parseFloat(amount) > effectiveMaxDeposit) {
                setErrorMessage(t("validation.maxamount", { max: effectiveMaxDeposit }));
            } else {
                setErrorMessage("");
            }


            setReamount(isNaN(reamountValue) ? "" : reamountValue.toFixed(2));
        }
    }, [amount, depositDetails]);


    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };

    useEffect(() => {
        if (isCooldown && timer > 0) {
            const intervalId = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer - 1 <= 0) {
                        clearInterval(intervalId);
                        setIsCooldown(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);

            return () => clearInterval(intervalId);
        }
    }, [isCooldown, timer]);

    useEffect(() => {
        const savedTimerData = sessionStorage.getItem("cooldownTimer");
        if (savedTimerData) {
            const { endTime, isCooldown } = JSON.parse(savedTimerData);
            const now = Date.now();
            const timeLeft = Math.round((endTime - now) / 1000);

            if (isCooldown && timeLeft > 0) {
                setTimer(timeLeft);
                setIsCooldown(true);
            } else {
                sessionStorage.removeItem("cooldownTimer");
            }
        }
    }, []);

    const handleSubmitClick = () => {
        setTimer(process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15);
        setIsDisabled(true);
    };

    useEffect(() => {
        if (!isLoading && isSuccess) {
            if (selectedCategory !== "paymentgateway") {
                dispatch(
                    setAlert({
                        isOpen: true,
                        message: t("walletcard.depositpage.successmessage"),
                        variant: "success",
                    })
                );
            }

            reset();
            TrackFbq('trackCustom', 'CompleteDeposit');
        }
        if (!isLoading && isError) {
            dispatch(
                setAlert({
                    isOpen: true,
                    message: error?.data?.message,
                    variant: "error",
                })
            );
            reset();
        }
    }, [isLoading, isSuccess, isError]);

    const [cryptoAmount, setCryptoAmount] = useState('');
    const [triggerGetCryptoAmount, { cryptoAmountData, cryptoAmountLoading, cryptoAmountError }] = useLazyGetCryptoAmountQuery();

    const getCryptoAmount = async (amount, bankCode, paymentGateway) => {
        const data = await triggerGetCryptoAmount({
            bankCode,
            amount,
            paymentGateway,
        }).unwrap();

        return data.result;
    };

    useEffect(() => {
        const fetchCryptoAmount = async () => {
            if (
                selectedCategory === 'paymentgateway' &&
                selectedQuickpayBank &&
                selectedQuickpay &&
                amount &&
                depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto
            ) {
                const result = await getCryptoAmount(amount, selectedQuickpayBank.bankCode, selectedQuickpay);
                setCryptoAmount(result);
            } else {
                setCryptoAmount('');
            }
        };
        fetchCryptoAmount();
    }, [selectedCategory, selectedQuickpayBank, selectedQuickpay, amount, depositDetails]);

    const {
        data: userBankAccounts,
        isLoading: isUserBankAccountsLoading,
    } = useGetBankAccountsQuery(undefined, {
        skip: !isKR || selectedCategory !== 'paymentgateway', // Only fetch if KR and paymentgateway tab is selected
    });

    const {
        data: depositDesc,
        isLoading: isDepositDescLoading,
        isError: isDepositDescError,
        isSuccess: isDepositDescSuccess,
        error: depositDescError,
    } = useGetDepositDescQuery();


    const [selectedUserBankId, setSelectedUserBankId] = useState("");

    const selectedUserBank = userBankAccounts?.result?.data?.find(
        (b) => `${b.bankCode}-${b.bankAccountNumber}` === selectedUserBankId
    );
    const bankConfigMap = userBankAccounts?.result?.bankConfigs?.reduce((acc, cfg) => {
        acc[cfg.bankCode] = cfg.bankName;
        return acc;
    }, {});
    useEffect(() => {
        // Pre-select the first bank account for KR users
        if (isKR && userBankAccounts?.result?.data?.length > 0 && !selectedUserBankId) {
            const firstBank = userBankAccounts.result.data[0];
            setSelectedUserBankId(`${firstBank.bankCode}-${firstBank.bankAccountNumber}`);
        }
    }, [isKR, userBankAccounts, selectedUserBankId]);

    if (!depositDetails?.paymentGateways) return <CircularProgress />;

    const MobileTnc = () => {
        return (
            <Dialog onClose={() => { setOpenTnc(false) }} open={openTnc} sx={{
                "& .MuiPaper-root": {
                    bgcolor: theme.palette.background.paper,
                    mx: 3,
                    width: "100%",
                    "&::-webkit-scrollbar": {
                        width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                        backgroundColor: "#2a2a2a",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: "8px",
                    },
                }
            }}>
                <DialogTitle fontWeight={"bold"}
                    sx={{
                        backgroundColor: theme.palette.primary.main || "white",
                        py: 1,
                        px: 1.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Typography color={process.env.REACT_APP_COLOR_TEXT || 'white'}
                        fontSize={"small"}
                        fontWeight={"bold"}
                    > {"Terms and condition applied"}</Typography>

                    <CloseIcon onClick={() => { setOpenTnc(false) }} />
                </DialogTitle>

                <DialogContent sx={{
                    px: 3,
                    mt: 2
                }}>
                    <Typography dangerouslySetInnerHTML={{ __html: depositDesc?.result }}
                    />
                </DialogContent>
            </Dialog>

        )
    }

    return (
        <Box px={3} sx={{
            py: { xs: 10, sm: 0, md: 0, lg: 0 },
            background: !isLightTheme ? theme.palette.background.paper : undefined,
            minHeight: "100vh"
        }} >
            <Dialog open={open} onClose={handlePreviewClose} maxWidth="sm">
                {selectedBank?.qrCodeUrl && (
                    <img
                        src={selectedBank?.qrCodeUrl}
                        alt="QR Code Full"
                        style={{
                            width: "100%",
                            height: "auto",
                        }}
                    />
                )}
            </Dialog>

            <MobileTnc />
            <Typography mb={1} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                fontSize: "12px"
            }}>
                {t("walletcard.depositpage.paymentMethod")}
            </Typography>

            <Tabs
                onChange={handleTabChange}
            >
                {
                    sortedDepositType
                        .map((type, index) => (
                            <Tab
                                icon={
                                    <Image
                                        width={"65px"}
                                        height={"50px"}
                                        src={process.env.REACT_APP_PROFILE + `/payment_method_` + index + `.png`}
                                        sx={{
                                            border:
                                                index === tabValue && `2px solid ${theme.palette.primary.main}` ||
                                                index !== tabValue && `1px solid ${theme.palette.button.faded.main}`,
                                            borderRadius: "5px",
                                            background: "rgba(255,255,255,0.25)",
                                            py: 1,
                                            px: 2,
                                            flex: 0,
                                        }}
                                    />}
                                key={index}
                                label={
                                    <Typography textTransform={"none"} textAlign={"center"} color={"primary"} fontWeight={600} fontSize={"9px"}>
                                        {type.label}
                                    </Typography>
                                }
                                sx={{
                                    pl: 0,
                                    pt: 0,
                                    pb: 0
                                }}
                            />
                        ))
                }
            </Tabs>
            {selectedCategory === "paymentgateway" && (
                <Box display="flex" flexDirection="column">
                    <Typography mt={1} mb={1} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                        fontSize: "12px"
                    }}>
                        {t("walletcard.depositpage.quickpay.method")}
                    </Typography>


                    <Grid container spacing={2}>
                        {depositDetails?.paymentGateways && Object.keys(depositDetails?.paymentGateways)?.map((method) => (
                            <Grid item xs={6} sm={3}>
                                <Box
                                    sx={{
                                        border: 2.5,
                                        borderRadius: 2,
                                        borderColor:
                                            selectedQuickpay ===
                                                depositDetails?.paymentGateways[method]?.paymentGateway
                                                ? theme.palette.primary.main
                                                : theme.palette.button.faded.main,
                                        display: "flex",
                                        height: 50,
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        p: 1,
                                        backgroundColor: darken(
                                            theme.palette.background.paper,
                                            0.1
                                        ),
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        setSelectedQuickpay(
                                            depositDetails?.paymentGateways[method]?.paymentGateway
                                        );
                                        setAllQuickpayBank(
                                            depositDetails?.paymentGateways[method]?.banks
                                        );

                                        const pgBanks = depositDetails?.paymentGateways[method]?.banks || [];
                                        setSelectedQuickpayBank(pgBanks[0] ?? null);
                                    }}
                                >
                                    <Image
                                        width="40px"
                                        height="40px"
                                        src={
                                            depositDetails?.paymentGateways[method]
                                                ?.paymentGatewayIcon
                                        }
                                    />
                                    <Typography ml={1} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                                        {depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAY" ? "ESEWA" :
                                            depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAYHK" ? "LNWPAY" :
                                                depositDetails?.paymentGateways[method]?.name || depositDetails?.paymentGateways[method]?.paymentGateway
                                        }
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>

                    {selectedQuickpay && (
                        <>
                            {isKR && selectedQuickpay === 'SULIFU' ? (
                                <Box my={1}>
                                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={1}>
                                        {t("walletcard.depositpage.quickpay.bank")}
                                    </Typography>
                                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                                        {isUserBankAccountsLoading ? (
                                            <CircularProgress size={24} />
                                        ) : userBankAccounts?.result?.data?.length > 0 ? (

                                            <FormControl fullWidth variant="outlined" size="small">
                                                <InputLabel sx={{ color: process.env.REACT_APP_COLOR_TEXT || "white" }}>
                                                    {t("walletcard.bankaccountpage.bankaccount")}
                                                </InputLabel>
                                                <Select
                                                    value={selectedUserBankId || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setSelectedUserBankId(value);
                                                    }}
                                                    label={t("walletcard.bankaccountpage.bankaccount")}
                                                    renderValue={(selectedKey) => {
                                                        const selectedBank = userBankAccounts?.result?.data?.find(
                                                            (bank) => `${bank.bankCode}-${bank.bankAccountNumber}` === selectedKey
                                                        );
                                                        return selectedBank ? (
                                                            <Box display="flex" flexDirection="column">
                                                                <Typography variant="body2" fontWeight="bold">
                                                                    {bankConfigMap?.[selectedBank.bankCode] || selectedBank.bankCode}
                                                                </Typography>
                                                                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                                                    {selectedBank.bankAccountNumber}
                                                                </Typography>
                                                            </Box>
                                                        ) : (
                                                            ""
                                                        );
                                                    }}
                                                    sx={{
                                                        color: process.env.REACT_APP_COLOR_TEXT || "white",
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: theme.palette.button.faded.main,
                                                        },
                                                        "& .MuiSvgIcon-root": {
                                                            color: process.env.REACT_APP_COLOR_TEXT || "white",
                                                        },
                                                    }}
                                                >
                                                    {userBankAccounts?.result?.data?.map((bank) => {
                                                        const key = `${bank.bankCode}-${bank.bankAccountNumber}`;
                                                        return (
                                                            <MenuItem key={key} value={key}>
                                                                <Box display="flex" flexDirection="column">
                                                                    <Typography variant="body2" fontWeight="bold">
                                                                        {bankConfigMap?.[bank.bankCode] || bank.bankCode}
                                                                    </Typography>
                                                                    <Tooltip title={bank.bankAccountNumber}>
                                                                        <Typography variant="caption" noWrap sx={{ opacity: 0.8 }}>
                                                                            {bank.bankAccountNumber}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Box>
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>

                                        ) : (
                                            <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{ flexGrow: 1 }}>
                                                {t("walletcard.bankaccountpage.no_bank_account")}
                                            </Typography>
                                        )}
                                        <Button
                                            variant="contained"
                                            onClick={() =>
                                                navigate(Constant.getPath("/profileWallet"), {
                                                    state: { screen: "bank account" },
                                                })}
                                            sx={{ whiteSpace: 'nowrap', height: '56px' }}
                                        >
                                            <AddIcon sx={{ fontSize: 30 }} />
                                        </Button>
                                    </Box>
                                </Box>
                            ) : (
                                <>
                                    <Box my={1}>
                                        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{ fontSize: "12px" }}>
                                            {t("walletcard.depositpage.quickpay.bank")}
                                        </Typography>
                                    </Box>

                                    {(() => {
                                        // ── Helper: check if flat array has category field ──
                                        const isGrouped = Array.isArray(allQuickpayBank) && allQuickpayBank.some(b => b?.category);
                                        const groupedQuickpayBank = isGrouped
                                            ? allQuickpayBank.reduce((acc, bank) => {
                                                const cat = bank.category || "BANK";
                                                if (!acc[cat]) acc[cat] = [];
                                                acc[cat].push(bank);
                                                return acc;
                                            }, {})
                                            : null;

                                        return isGrouped ? (
                                            <>
                                                {/* ── Category Selector ── */}
                                                <Grid container spacing={1} mb={1}>
                                                    {Object.keys(groupedQuickpayBank).map((category) => (
                                                        <Grid item xs={6} key={category}>
                                                            <Box
                                                                sx={{
                                                                    border: 1,
                                                                    borderRadius: 2,
                                                                    borderColor:
                                                                        selectedQuickpayBankCategory === category
                                                                            ? theme.palette.primary.main
                                                                            : theme.palette.button.faded.main,
                                                                    display: "flex",
                                                                    height: 44,
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                    backgroundColor: darken(theme.palette.background.paper, 0.1),
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedQuickpayBankCategory(category);
                                                                    setSelectedQuickpayBank(null);
                                                                    setAmount(0);
                                                                    setReamount(0);
                                                                }}
                                                            >
                                                                {category === "BANK"
                                                                    ? <AccountBalanceIcon sx={{ color: "white", fontSize: 18 }} />
                                                                    : <WalletIcon sx={{ color: "white", fontSize: 18 }} />
                                                                }
                                                                <Typography color="white" fontSize="12px" fontWeight="bold">
                                                                    {category === "BANK"
                                                                        ? t("walletcard.depositpage.bankSubTitle")
                                                                        : t("walletcard.depositpage.ewallet")}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                                {/* ── Filtered Dropdown based on selected category ── */}
                                                <Select
                                                    value={selectedQuickpayBank || ""}
                                                    displayEmpty
                                                    sx={{
                                                        fontSize: "12px",
                                                        width: "100%",
                                                        "& .MuiSelect-select": { padding: "10px 10px" },
                                                        color: process.env.REACT_APP_COLOR_TEXT || "white",
                                                        "& .MuiOutlinedInput-notchedOutline": { borderColor: theme.palette.button.faded.main },
                                                        "& .MuiSvgIcon-root": { color: process.env.REACT_APP_COLOR_TEXT || "white" },
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: darken(theme.palette.background.paper, 0.2),
                                                                borderRadius: 2,
                                                                "& .MuiList-root": { padding: 0 },
                                                            },
                                                        },
                                                    }}
                                                    renderValue={(selected) => {
                                                        if (!selected) return <span style={{ color: "#aaa" }}>{t("walletcard.depositpage.selectbank")}</span>;
                                                        return (
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                {selected?.iconUrl && (
                                                                    <img src={selected.iconUrl} alt={selected.bankName}
                                                                        style={{ width: 24, height: 24, objectFit: "contain", borderRadius: 4 }} />
                                                                )}
                                                                <span>{selected.bankName}</span>
                                                            </Box>
                                                        );
                                                    }}
                                                    onChange={(e) => {
                                                        setSelectedQuickpayBank(e.target.value);
                                                        setAmount(0);
                                                        setReamount(0);
                                                    }}
                                                >
                                                    {(groupedQuickpayBank[selectedQuickpayBankCategory] || []).map((quickpayBank) => (
                                                        <MenuItem key={quickpayBank?.bankCode} value={quickpayBank}
                                                            sx={{ display: "flex", alignItems: "center", gap: "10px", py: "8px" }}>
                                                            {quickpayBank?.iconUrl && (
                                                                <img src={quickpayBank.iconUrl} alt={quickpayBank.bankName}
                                                                    style={{ width: 28, height: 28, objectFit: "contain", borderRadius: 4 }} />
                                                            )}
                                                            <span style={{ fontSize: "13px" }}>{quickpayBank?.bankName}</span>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </>
                                        ) : (
                                            // ── Flat array — no category, display as normal dropdown ──
                                            <Select
                                                value={selectedQuickpayBank || ""}
                                                displayEmpty
                                                sx={{
                                                    fontSize: "12px",
                                                    width: "100%",
                                                    "& .MuiSelect-select": { padding: "10px 10px" },
                                                    color: process.env.REACT_APP_COLOR_TEXT || "white",
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: theme.palette.button.faded.main },
                                                    "& .MuiSvgIcon-root": { color: process.env.REACT_APP_COLOR_TEXT || "white" },
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: darken(theme.palette.background.paper, 0.2),
                                                            borderRadius: 2,
                                                            "& .MuiList-root": { padding: 0 },
                                                        },
                                                    },
                                                }}
                                                renderValue={(selected) => {
                                                    if (!selected) return <span style={{ color: "#aaa" }}>{t("walletcard.depositpage.selectbank")}</span>;
                                                    return (
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                            {selected?.iconUrl && (
                                                                <img src={selected.iconUrl} alt={selected.bankName}
                                                                    style={{ width: 24, height: 24, objectFit: "contain", borderRadius: 4 }} />
                                                            )}
                                                            <span>{selected.bankName}</span>
                                                        </Box>
                                                    );
                                                }}
                                                onChange={(e) => {
                                                    setSelectedQuickpayBank(e.target.value);
                                                    setAmount(0);
                                                    setReamount(0);
                                                }}
                                            >
                                                {(allQuickpayBank || []).map((quickpayBank) => (
                                                    <MenuItem key={quickpayBank?.bankCode} value={quickpayBank}
                                                        sx={{ display: "flex", alignItems: "center", gap: "10px", py: "8px" }}>
                                                        {quickpayBank?.iconUrl && (
                                                            <img src={quickpayBank.iconUrl} alt={quickpayBank.bankName}
                                                                style={{ width: 28, height: 28, objectFit: "contain", borderRadius: 4 }} />
                                                        )}
                                                        <span style={{ fontSize: "13px" }}>{quickpayBank?.bankName}</span>
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        );
                                    })()}
                                </>
                            )}
                            <Box mt={1}>
                                <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                                    fontSize: "12px"
                                }}>
                                    {t("walletcard.depositpage.quickpay.depositamount")}
                                </Typography>

                                <Grid mt={1} item container justifyContent="space-between">
                                    <Grid item>
                                        <Typography fontSize="x-small" variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} >{t("Deposit Quota")}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography fontSize="x-small" variant="subtitle1" color="#FDB813" >{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                                    </Grid>
                                </Grid>

                                <form onSubmit={handleQpSubmit(submitQuickpay)}>
                                    <FormTextField
                                        label={`${t("walletcard.depositpage.quickpay.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                                            })`}
                                        control={qpControl}
                                        controllerName="amount"
                                        defaultValue={""}
                                        placeholder={`Min ${minDeposit}`}
                                        size="small"
                                        onChange={handleAmountChange}
                                        style={{
                                            marginTop: 1,
                                            display: "block",
                                        }}
                                    />

                                    {depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto && (
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item>
                                                <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">
                                                    {t("walletcard.depositpage.cryptoamount")} :
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                                                    {cryptoAmount}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}

                                    <Grid wrap="nowrap" container py={2}>
                                        {depositDetails?.defaultAmountSelection?.map((item, index) => (
                                            <Grid item>
                                                <Button
                                                    key={index}
                                                    disableRipple
                                                    sx={{
                                                        "&.MuiButtonBase-root:hover": {
                                                            backgroundColor: "transparent",
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                                                        setQpValue("amount", item.content, {
                                                            shouldValidate: true,
                                                        });
                                                        setAmount(item.content);
                                                        // Update reamount when clicking on the button
                                                        const processingFee = selectedQuickpayBank?.processingFee || 0;
                                                        const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                                                        setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                                                    }}
                                                >
                                                    <Box display="flex"
                                                        flex={1}
                                                        sx={{
                                                            border: 1,
                                                            borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                            boxShadow: 3,
                                                            borderRadius: "5px",
                                                        }}
                                                        justifyContent="center"
                                                        alignItems="center"
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                                fontSize: "12px",
                                                                paddingY: 1,
                                                                paddingX: 0.6,
                                                            }}
                                                        >
                                                            {item.content}
                                                        </Typography>
                                                    </Box>
                                                </Button>
                                            </Grid>
                                        ))}
                                    </Grid>
                                    <Box display="flex" flexDirection={"column"}>
                                        <Button disabled={gatewaySubmit} color="success" variant="contained" type="submit">
                                            {t("walletcard.depositpage.quickpay.deposit")}
                                        </Button>

                                        <Typography mt={1.5}
                                            fontSize={"12px"}
                                            fontWeight={"bold"}
                                            color={theme.palette.primary.main || "white"}
                                            textAlign={"center"}
                                            sx={{
                                                textDecoration: "underline"
                                            }}
                                            onClick={() => {
                                                setOpenTnc(true);
                                            }}
                                        >
                                            {"Terms and conditions Applied*"}
                                        </Typography>

                                        {/* placeholder to autoscroll */}
                                        <Box ref={pgScrollRef} />
                                    </Box>
                                </form>
                            </Box>
                        </>
                    )}
                </Box >
            )
            }

            {
                selectedCategory === "bank" && (
                    <Box>
                        <Box mt={1}>
                            <Typography
                                fontWeight="bold"
                                color={process.env.REACT_APP_COLOR_TEXT || "white"}
                                mb={1}
                                sx={{
                                    fontSize: "12px"
                                }}
                            >
                                {t("walletcard.depositpage.quickpay.method")}
                            </Typography>

                            <Select
                                value={selectedBankMethod}
                                sx={{
                                    fontSize: "12px",
                                    width: "100%",
                                    "& .MuiSelect-select": {
                                        padding: "10px 10px",
                                    },
                                    color: process.env.REACT_APP_COLOR_TEXT || "white",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: theme.palette.button.faded.main,
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: process.env.REACT_APP_COLOR_TEXT || "white",
                                    },

                                }}
                                onChange={(e) => {
                                    setSelectedBankMethod(e.target.value);
                                    setSelectedBank(null);
                                }}
                            >
                                {bankMethodOptions.map((method) => (
                                    <MenuItem key={method} value={method}>
                                        {method === "bank" ? "Bank" : "QR Code"}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>

                        <Typography mt={1} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}
                            sx={{
                                fontSize: "12px"
                            }}>
                            {t("walletcard.depositpage.title")}
                        </Typography>
                        <Box display="flex" flexDirection="column">
                            <Box sx={{
                                borderRadius: 2
                            }}>
                                <RadioGroup
                                    value={selectedBank?.id?.toString() || ""}
                                    onChange={(e) => {
                                        const selected = bankDetails.find(
                                            item => item.id === Number(e.target.value)
                                        );
                                        setSelectedBank(selected);
                                        setAmount(0);
                                        setReamount(0);
                                    }}>
                                    {filteredBankDetails.map(item => (
                                        <Box key={item.id}>
                                            <FormControlLabel
                                                value={item.id.toString()}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "& .MuiSvgIcon-root": {
                                                                color: `${theme.palette.primary.main} !important`,
                                                            },
                                                            "&.Mui-checked .MuiSvgIcon-root": {
                                                                color: `${theme.palette.primary.main}!important`,
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Box display="flex" alignItems="center" gap={1.5}>
                                                        <Image height={30} width="auto" src={item.thumbnailUrl} style={{ objectFit: "contain" }} />
                                                        <Box>
                                                            <Typography fontSize="x-small">
                                                                {item.bankName}
                                                            </Typography>

                                                            {selectedBank?.id === item.id && (
                                                                <Box>
                                                                    <Typography
                                                                        sx={{
                                                                            color: process.env.REACT_APP_COLOR_TEXT,
                                                                            fontSize: 'x-small',
                                                                        }}
                                                                    >
                                                                        {item.bankAccountName}
                                                                        <br />
                                                                        {item.bankAccountNumber}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                }
                                                sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
                                            />
                                        </Box>
                                    ))}
                                </RadioGroup>
                            </Box>
                            {selectedBankMethod === "qrCode" && selectedBank?.qrCodeUrl && (
                                <Box display="flex" pl={1} mt={2} flexDirection="column" >
                                    <Box>
                                        <img
                                            src={selectedBank.qrCodeUrl}
                                            alt="QR Code"
                                            style={{ width: "150px", height: "150px", display: "block", margin: "0 auto" }}
                                            onClick={handlePreviewOpen}
                                        />
                                    </Box>
                                </Box>
                            )}

                            {selectedBank && (
                                <>
                                    <Grid mt={1} item container justifyContent="space-between">
                                        <Grid item>
                                            <Typography fontSize="x-small" variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} >{t("Deposit Quota")}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography fontSize="x-small" variant="subtitle1" color="#FDB813" >{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Box display="flex" flexDirection="column">
                                        <Typography
                                            fontWeight="bold"
                                            color={process.env.REACT_APP_COLOR_TEXT || "white"}
                                            sx={{
                                                fontSize: "12px"
                                            }}
                                        >
                                            {t("walletcard.depositpage.amount")}
                                        </Typography>

                                        <form onSubmit={handleSubmit(submitDeposit)}>
                                            <FormTextField
                                                label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                                                    })`}
                                                control={control}
                                                controllerName="amount"
                                                defaultValue={""}
                                                placeholder={t("placeholder.minamount")}
                                                size="small"
                                                onChange={handleAmountChange}
                                                style={{
                                                    marginTop: 1,
                                                    display: "block",
                                                }}
                                            />
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="x-small">{t("walletcard.depositpage.processingfee")} : </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="x-small">
                                                        {process.env.REACT_APP_CURRENCY_CODE} {selectedBank?.processingFee || bankDetails[0]?.processingFee || '0.00'}

                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="x-small">{t("walletcard.depositpage.receivableamount")} : </Typography>
                                                </Grid>
                                                <Grid item>
                                                    {errorMessage ? (
                                                        // Show error message in place of receivable amount
                                                        <Typography fontWeight="bold" color="error" align="right" fontSize="x-small">
                                                            {errorMessage}
                                                        </Typography>
                                                    ) : (
                                                        // Show receivable amount if no error
                                                        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="x-small">
                                                            {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                                                        </Typography>
                                                    )}

                                                </Grid>
                                            </Grid>
                                            <Grid my={1} container wrap="nowrap" display={"flex"} justifyContent={"space-between"}>
                                                {depositDetails?.defaultAmountSelection?.map((item, index) => (
                                                    <Grid item>
                                                        <Button
                                                            key={index}
                                                            disableRipple
                                                            sx={{
                                                                "&.MuiButtonBase-root:hover": {
                                                                    backgroundColor: "transparent",
                                                                },
                                                            }}
                                                            onClick={() => {
                                                                TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                                                                setValue("amount", item.content, {
                                                                    shouldValidate: true,
                                                                });
                                                                const processingFee = (selectedBank?.processingFee || bankDetails[0]?.processingFee) || 0;
                                                                const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                                                                setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                                                            }}

                                                        >
                                                            <Box display="flex"
                                                                flex={1}
                                                                sx={{
                                                                    border: 1,
                                                                    borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                                    boxShadow: 3,
                                                                    borderRadius: "5px",
                                                                }}
                                                                justifyContent="center"
                                                                alignItems="center"
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                                        fontSize: "12px",
                                                                        paddingY: 1,
                                                                        paddingX: 0.6,
                                                                    }}
                                                                >
                                                                    {item.content}
                                                                </Typography>
                                                            </Box>
                                                        </Button>
                                                    </Grid>
                                                ))}
                                            </Grid>

                                            <Typography
                                                fontWeight="bold"
                                                color={process.env.REACT_APP_COLOR_TEXT || "white"}
                                                mt={1}
                                                sx={{
                                                    fontSize: "12px"
                                                }}
                                            >
                                                {t("walletcard.depositpage.receipt")}
                                            </Typography>
                                            <FormFileInput
                                                label={t("walletcard.depositpage.receipt")}
                                                control={control}
                                                controllerName="receipt"
                                                defaultValue={""}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                type="file"
                                                margin="dense"
                                                size="small"
                                            />

                                            <Box alignSelf="center" mt={3} mb={3}>
                                                <Button
                                                    color="success"
                                                    variant="contained"
                                                    type="submit"
                                                    disabled={isCooldown || eWalletSubmit}
                                                    onClick={handleSubmitClick}
                                                    startIcon={isCooldown && <CircularProgress size={20} />}
                                                    sx={{
                                                        width: "100%",
                                                        backgroundColor: isCooldown ? "red" : "success.main",
                                                        "&:hover": {
                                                            backgroundColor: isCooldown ? "red" : "success.dark",
                                                        },
                                                        "&.Mui-disabled": {
                                                            backgroundColor: "red",
                                                            color: "white",
                                                        },
                                                    }}
                                                >
                                                    {isCooldown ? `Deposit (${timer}s)` : 'Deposit'}
                                                </Button>
                                                <Typography mt={1.5}
                                                    fontSize={"12px"}
                                                    fontWeight={"bold"}
                                                    color={theme.palette.primary.main || "white"}
                                                    textAlign={"center"}
                                                    sx={{
                                                        textDecoration: "underline"
                                                    }}
                                                    onClick={() => {
                                                        setOpenTnc(true);
                                                    }}
                                                >
                                                    {"Terms and conditions Applied*"}
                                                </Typography>

                                                <Box ref={bankScrollRef} />
                                            </Box>
                                        </form>
                                    </Box>
                                </>
                            )}

                        </Box>
                        {/* </TabPanel> */}
                    </Box>
                )
            }

            {
                selectedCategory === "ewallet" && (
                    <Box>
                        <Box mt={1}>
                            <Typography fontWeight="bold"
                                fontSize="12px"
                                mb={1}
                                color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                                {t("walletcard.depositpage.quickpay.method")}
                            </Typography>

                            <Select
                                value={selectedQrCodeMethod}
                                sx={{
                                    fontSize: "12px",
                                    width: "100%",
                                    "& .MuiSelect-select": {
                                        padding: "10px 10px",
                                    },
                                    color: process.env.REACT_APP_COLOR_TEXT || "white",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: theme.palette.button.faded.main,
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: process.env.REACT_APP_COLOR_TEXT || "white",
                                    },

                                }}
                                onChange={(e) => {
                                    setSelectedQrCodeMethod(e.target.value);
                                    setSelectedEwalletBank(null);

                                }}
                            >
                                <MenuItem value="bank">Bank</MenuItem>
                                <MenuItem value="qrCode">QR Code</MenuItem>
                            </Select>
                        </Box>

                        <Typography fontWeight="bold"
                            fontSize="12px"
                            mt={1}
                            color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                            {t("walletcard.depositpage.title")}
                        </Typography>

                        <RadioGroup
                            value={selectedEwalletBank?.id?.toString() || ""}
                            onChange={(e) => {
                                const selected = eWalletDetails.find(
                                    item => item.id === Number(e.target.value)
                                );
                                setSelectedEwalletBank(selected);
                                setAmount(0);
                                setReamount(0);
                            }}>

                            {eWalletDetails.map(item => (
                                <Box key={item.id}>
                                    <FormControlLabel
                                        value={item.id.toString()}
                                        control={<Radio size="small" sx={{
                                            "& .MuiSvgIcon-root": {
                                                color: `${theme.palette.primary.main} !important`,
                                            },
                                            "&.Mui-checked .MuiSvgIcon-root": {
                                                color: `${theme.palette.primary.main}!important`,
                                            },
                                        }}
                                        />
                                        }
                                        sx={{
                                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                            '&.Mui-checked': {
                                                color: process.env.REACT_APP_COLOR_TEXT,
                                            },
                                        }}
                                        label={
                                            <Box display="flex" alignItems="center" gap={1.5}>
                                                <Image height={30} width="auto" src={item.thumbnailUrl} style={{ objectFit: "contain" }} />
                                                <Box>
                                                    <Typography fontSize="x-small">
                                                        {item.bankName}
                                                    </Typography>

                                                    {selectedEwalletBank?.id === item.id && (
                                                        <Box>
                                                            <Typography
                                                                sx={{
                                                                    color: process.env.REACT_APP_COLOR_TEXT,
                                                                    fontSize: 'x-small',
                                                                }}
                                                            >
                                                                {item.bankAccountName}
                                                                <br />
                                                                {item.bankAccountNumber}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        }
                                        sx={{ color: process.env.REACT_APP_COLOR_TEXT }}
                                    />
                                </Box>
                            ))}
                        </RadioGroup>
                        {
                            selectedEwalletBank && (
                                <>
                                    {selectedQrCodeMethod === "qrCode" && selectedEwalletBank?.qrCodeUrl && (
                                        <Box display="flex" pl={1} mt={2} flexDirection="column" >
                                            <Box>
                                                <img
                                                    src={selectedEwalletBank.qrCodeUrl}
                                                    alt="QR Code"
                                                    style={{ width: "150px", height: "150px", display: "block", margin: "0 auto" }}
                                                />
                                            </Box>
                                        </Box>
                                    )}

                                    <Box mt={1}>
                                        <Grid item container justifyContent="space-between">
                                            <Grid item>
                                                <Typography fontSize="x-small" variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} >{t("Deposit Quota")}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography fontSize="x-small" variant="subtitle1" color="#FDB813" >{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Box>
                                            <Typography
                                                fontWeight="bold"
                                                color={process.env.REACT_APP_COLOR_TEXT || "white"}
                                                sx={{
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {t("walletcard.depositpage.amount")}
                                            </Typography>

                                            <form onSubmit={handleSubmit(submitDeposit)}>
                                                <FormTextField
                                                    label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                                                        })`}
                                                    control={control}
                                                    controllerName="amount"
                                                    defaultValue={""}
                                                    placeholder={`Min ${minDeposit}`}
                                                    size="small"
                                                    onChange={handleAmountChange}
                                                    style={{
                                                        marginTop: 1,
                                                        display: "block",
                                                    }}

                                                />
                                                <Grid container spacing={1} alignItems="center">
                                                    <Grid item>
                                                        <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="x-small">{t("walletcard.depositpage.processingfee")} : </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="x-small">
                                                            {process.env.REACT_APP_CURRENCY_CODE} {selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee || '0.00'}

                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={1} alignItems="center">
                                                    <Grid item>
                                                        <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="x-small">{t("walletcard.depositpage.receivableamount")} : </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        {errorMessage ? (
                                                            // Show error message in place of receivable amount
                                                            <Typography fontWeight="bold" color="error" align="right" fontSize="x-small">
                                                                {errorMessage}
                                                            </Typography>
                                                        ) : (
                                                            // Show receivable amount if no error
                                                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="x-small">
                                                                {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                                                            </Typography>
                                                        )}

                                                    </Grid>
                                                </Grid>
                                                <Grid my={1} container wrap="nowrap" display={"flex"} justifyContent={"space-between"}>
                                                    {depositDetails?.defaultAmountSelection?.map((item, index) => (
                                                        <Grid item>
                                                            <Button
                                                                key={index}
                                                                disableRipple
                                                                sx={{
                                                                    "&.MuiButtonBase-root:hover": {
                                                                        backgroundColor: "transparent",
                                                                    },
                                                                }}
                                                                onClick={() => {
                                                                    TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                                                                    setValue("amount", item.content, {
                                                                        shouldValidate: true,
                                                                    });
                                                                    const processingFee = (selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee) || 0;
                                                                    const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                                                                    setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                                                                }}

                                                            >
                                                                <Box display="flex"
                                                                    flex={1}
                                                                    sx={{
                                                                        border: 1,
                                                                        borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                                        boxShadow: 3,
                                                                        borderRadius: "5px",
                                                                    }}
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                                                            fontSize: "12px",
                                                                            paddingY: 1,
                                                                            paddingX: 0.6,
                                                                        }}
                                                                    >
                                                                        {item.content}
                                                                    </Typography>
                                                                </Box>
                                                            </Button>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                                <Typography
                                                    fontWeight="bold"
                                                    color={process.env.REACT_APP_COLOR_TEXT || "white"}
                                                    mt={1}
                                                    sx={{
                                                        fontSize: "12px"
                                                    }}
                                                >
                                                    {t("walletcard.depositpage.receipt")}
                                                </Typography>

                                                <FormFileInput
                                                    label={t("walletcard.depositpage.receipt")}
                                                    control={control}
                                                    controllerName="receipt"
                                                    defaultValue={""}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    type="file"
                                                    margin="dense"
                                                    size="small"
                                                />
                                                <Box alignSelf="center" mb={3} mt={3}>

                                                    <Button
                                                        color="success"
                                                        variant="contained"
                                                        type="submit"
                                                        disabled={isDisabled}
                                                        sx={{
                                                            width: "100%",
                                                            backgroundColor: isDisabled ? "red" : "success.main",
                                                            "&:hover": {
                                                                backgroundColor: isDisabled ? "red" : "success.dark",
                                                            },
                                                            "&.Mui-disabled": {
                                                                backgroundColor: "red",
                                                                color: "white",
                                                            },
                                                        }}

                                                        //onClick={handleClick}
                                                        startIcon={isDisabled && <CircularProgress size={20} />}
                                                    >
                                                        {isDisabled ? `${timer}s` : 'Deposit'}
                                                    </Button>

                                                    <Typography mt={1.5}
                                                        fontSize={"12px"}
                                                        fontWeight={"bold"}
                                                        color={theme.palette.primary.main || "white"}
                                                        textAlign={"center"}
                                                        sx={{
                                                            textDecoration: "underline"
                                                        }}
                                                        onClick={() => {
                                                            setOpenTnc(true);
                                                        }}
                                                    >
                                                        {"Terms and conditions Applied*"}
                                                    </Typography>

                                                    <Box ref={eWalletScrollRef} />
                                                </Box>
                                            </form>
                                        </Box>
                                    </Box>
                                </>
                            )
                        }
                    </Box>
                )
            }

        </Box >
    );
};

export default DepositMobile;